// Direct link from AONE into AERIS, already signed in: /open/aeris[?to=<aeris path>].
// The page (pages/OpenAeris.js) mints a short-lived signed SSO URL via
// GET /auth/sso/aeris and replaces itself with it — same tab, no popup.

export const AERIS_OPEN_PATH = '/open/aeris';

// Same rule as backend/src/utils/safeRelativePath.js (the backend re-checks and
// AERIS checks again). Same-host relative paths only: `//host`, `/\host` and
// control characters (browsers drop tab/CR/LF, so "/\t/host" is "//host") would
// all turn a trusted link into an open redirect.
export function safeRelativePath(raw) {
  if (typeof raw !== 'string') return null;
  if (!raw || raw.length > 512) return null;
  if (raw[0] !== '/') return null;
  if (raw[1] === '/' || raw[1] === '\\') return null;
  if (raw.includes('\\')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\x00-\x1f\x7f]/.test(raw)) return null;
  return raw;
}

// AONE-relative href for the open-link, optionally deep-linking inside AERIS.
export function aerisOpenHref(to) {
  const safe = to ? safeRelativePath(to) : null;
  return safe ? `${AERIS_OPEN_PATH}?to=${encodeURIComponent(safe)}` : AERIS_OPEN_PATH;
}
